export default __webpack_public_path__ + "static/media/m_logo.d48c75c7.svg";